import { withStyles } from '@material-ui/core';
import SearchField from './SearchField';
import styles from './SearchField.styles';

export default withStyles(styles)(SearchField);
